<template>
  <button
    type="button"
    class="btn btn-primary btn-sm"
    data-toggle="modal"
    :data-target="!agenda ? '#add-agenda' : `#edit-agenda-${agenda.id}`"
    ref="toggle-btn"
  >
      <i class="las la-pencil-alt" v-if="!!agenda"></i>
      <span v-else>{{ message }}</span>
  </button>

  <div
    class="modal fade"
    :id="!agenda ? 'add-agenda' : `edit-agenda-${agenda.id}`"
    tabindex="-1"
    role="dialog"
    aria-labelledby="add-agenda-label"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-xl" role="document">
      <div class="modal-content">
        <FormKit
          type="form"
          @submit="addAgenda"
          :actions="false"
          #default="{ isLoading }"
          :id="!agenda ? 'add-agenda-form' : `edit-agenda-${agenda.id}-form`"
        >
          <div class="modal-header">
            <h5 class="modal-title" id="add-agenda-label">{{ message }}</h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <FormKit
              v-if="!agenda"
              type="select"
              label="Activiteit"
              :options="activityOptions"
              class="mb-4"
              name="activity_id"
            />

            <FormKit
              type="text"
              label="Omschrijving"
              help="De omschrijving wordt alleen gebruikt zodat een champagnehuis kan identificeren waarvoor de kalender is."
              name="description"
              v-model="form.description"
            />

            <div class="row mt-4">
              <div class="col-12 col-md-6">
                <FormKit
                  type="date"
                  label="Datum vanaf"
                  name="date_from"
                  v-model="form.date_from"
                />
              </div>

              <div class="col-12 col-md-6">
                <FormKit
                  type="date"
                  label="Datum tot en met"
                  name="date_to"
                  v-model="form.date_to"
                />
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              data-dismiss="modal"
              :disabled="isLoading"
            >
              Annuleren
            </button>
            <button type="submit" class="btn btn-primary" :disabled="isLoading">
              {{ message }}
            </button>
          </div>
        </FormKit>
      </div>
    </div>
  </div>
</template>

<script>
import _ from "lodash";

export default {
  name: "AddAgendaModal",
  props: {
    agenda: {},
    activities: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    let form = !!this.agenda
      ? { ...this.agenda }
      : {
          description: "",
          date_from: "",
          date_to: "",
        };

    return {
      form,
      id: !this.agenda
        ? "add-agenda-form"
        : `edit-agenda-${this.agenda.id}-form`,
    };
  },
  methods: {
    async addAgenda(values) {
      try {
        let url = "/admin/api";

        if (!!this.agenda) {
          url += `/agendas/${this.agenda.id}`;

          await axios.patch(url, values);
        } else {
          url += `/agendas`;

          await axios.post(url, values);
        }

        this.$emit("on-update");
        this.$refs["toggle-btn"].click();
      } catch (e) {
        this.$formkit.setErrors(this.id, e?.response?.data?.errors ?? {});
      }
    },
  },
  computed: {
    message() {
      return !!this.agenda ? "Agenda bijwerken" : "Agenda toevoegen";
    },
    activityOptions() {
      return _.map(this.activities, (activity) => ({
        value: activity.id,
        label: activity.title,
      }));
    },
  },
};
</script>
